import { Provider as RollbarProvider, historyContext } from '@rollbar/react';
import { createBrowserHistory } from 'history';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './data/store';
import configureRollbar from './rollbar';

const { rollbar } = configureRollbar();

const history = createBrowserHistory();
history.listen(historyContext(rollbar));

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <RollbarProvider instance={rollbar}>
    <Provider store={store}>
      <App />
    </Provider>
  </RollbarProvider>,
);
